import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { filterProducts } from "../../store/products/productsAction";
import { fetchBrands } from "../../store/brands/brandsAction";
const locale = require('react-redux-i18n').I18n;

class Brand extends Component {
  state = {};

  componentDidMount() {
    // this.props.fetchBrands({ project_id: this.props.projectID });
  }

  onChange = e => {
    var keys = [];
    var checkbox = document.getElementsByClassName('cb-brands')
    for (var i = 0; i < checkbox.length; i++) {
      if (checkbox.item(i).checked) {
        keys.push(checkbox.item(i).name)
      }
    }
    this.props.filterProducts(keys);
  };

  render() {
    const brands = this.props.brands.map(val => (
      <li className="list__item">
        <label className="label--checkbox">
          <input
            type="checkbox"
            className="checkbox cb-brands"
            value="true"
            name={val.brand}
            defaultChecked={true}
            onChange={this.onChange}
          />
          &nbsp; {val.brand}
        </label>
      </li>
    ));
    return (
      <div className="col-sm-12 col-md-3 col-lg-2">
        <div className="box-brand">
          <p className="ttl-desktop">
            {locale.t('brandLabel')}<i className="la la-filter" />
          </p>
          <button
            className="btn btn-ttl hidden visible-xs"
            type="button"
            data-toggle="collapse"
            data-target="#collapseBrand"
            aria-expanded="false"
            aria-controls="collapseExample"
          >
            <p className="ttl-desktop">
              {locale.t('brandLabel')}<i className="la la-filter" />
            </p>
          </button>
          <div className="collapse dont-collapse-sm" id="collapseBrand">
            <ul className="list">{brands}</ul>
          </div>
        </div>
      </div>
    );
  }
}

Brand.propTypes = {
  filterProducts: PropTypes.func.isRequired,
  fetchBrands: PropTypes.func.isRequired,
  brands: PropTypes.array.isRequired,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  brands: state.brands.items,
  projectID: state.project.info.project_id,
  isFetching: state.brands.isFetching,
  l: state.i18n.locale,
});

export default connect(
  mapStateToProps,
  { filterProducts, fetchBrands }
)(Brand);
